import Waarning from "../../icons/Warning";
import colors from "../../styles/colors";

const Error = ({children, style, className}) => {

    return(
        <div style={{...styles.container, ...style}} className={className}>
            <Waarning fill={colors.error}/>
            <p style={styles.text} className="caption_12_light">{children}</p>
        </div>
    )

}

const styles = {
    container:{
        display: 'flex',
        flexDirection: 'row',
        gap: 5,
        width: '100%'
    },
    text: {
        color: colors.error,
        flex: 1,
        margin: 0
    }
}

export default Error